import React, {forwardRef} from 'react';
import {FondoPrestacion} from "./FondoPrestacion";
import PropTypes from 'prop-types';

export const FondoDescripcion = forwardRef(({datafondo}, ref)  => {

    return (
        <div ref={ref} className='mx-auto'>
            <FondoPrestacion
                datafondo={datafondo}
            />
        </div>
    );
});


FondoDescripcion.prototype = {
    datafondo: PropTypes.array,
}

FondoDescripcion.defaultProps = {
    datafondo: [],
}


